<template>
  <div
    class="wp_mobileFilterContainer wp_displayNoneDesktop"
    id="filterOverlayMobile"
    style="display: none;"
  >
    <div class="row p-0 m-0">
      <div class="col-12 p-0 m-0">
        <div class="wp_FilterHeader">
          <div class="row">
            <div class="col-6 wp_alignItems">
              <span
                class="wp_filtersBackarrow"
                @click.prevent="backButtonAction"
                data-test="mobileFilterBackSpan"
                id="mobileFilterBackSpan"
              >
                <i class="fas fa-chevron-left" data-test="mobileFilterBackIcon"
																			id="mobileFilterBackIcon"></i>
              </span>
              <h5
                data-test="mobileFilterFilterName"
                id="mobileFilterFilterName"
              >{{selectedFilters?'Filters':selectedFilters[0].filterName}}</h5>
            </div>
            <div class="col-6 position-relative">
              <span
                class="wp_filtersClearButton"
                @click.prevent="clearAllFilters"
                data-test="mobileFilterClearSpan"
                id="mobileFilterClearSpan"
              >Clear</span>
            </div>
          </div>
        </div>
        <div class="wp_filtersContentsContainer">
          <div class="row p-0 m-0">
            <div class="col-12 p-0 m-0">
              <div class="wp_fiterMobileButtonsContainer">
                <!-- content filter mobile -->
                <div class="slidingDiv" id="filterSlidingDivMobile">
                  <div
                    class="wp_CheckboxItemsContainer"
                    v-for="(filterValue, index) in filters.filterValues"
                    :key="filterValue+''+index"
                  >
                    <label
                      class="wp_CheckContainer"
                      :for="filterValue"
                      style="padding-left: 2rem"
                      :id="'filter-checkbox-label-'+filterValue+index"
                      :data-test="'mobileFilterFilterValue'+index"
                    >
                      {{filterValue}}{{filters.filterName === 'ratings'?'★':''}}
                      <input
                        type="checkbox"
                        :id="filterValue"
                        :value="filterValue"
                        :name="filterValue"
                        v-model="selectedFilters"
                        @change="applyFilter()"
                        checked="false"
                        :data-test="'mobileFilterFilterCheckBox'+index"
                      />
                      <span class="checkmark" :data-test="'mobileFilterCheckmark'+index"
																												:id="'mobileFilterCheckmark'+index"></span>
                    </label>
                  </div>
                </div>
                <!-- content filter mobile -->

                <!-- buttons filter mobile -->
                <ul id="mobileFilterCategoryChooser">
                  <li
                    class="show_hide position-relative"
                    v-for="(fil,index) in getFilter"
                    :key="index"
                    @click.prevent="assignFilter(fil)"
                    :data-test="'mobileFiltergetFilterName'+index"
                    :id="'mobileFiltergetFilterName'+index"
                  >
                    {{fil.filterName}}
                    <div class="wp_downArrowFilter">
                      <svg
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        class="wp_ArrowAccordion"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="451.847px"
                        height="451.847px"
                        viewBox="0 0 451.847 451.847"
                        style="enable-background:new 0 0 451.847 451.847;"
                        xml:space="preserve"
                        :data-test="'mobileFiltergetFilterSvg'+index"
                      >
                        <g>
                          <path
                            d="M225.923,354.706c-8.098,
                          0-16.195-3.092-22.369-9.263L9.27,
                          151.157c-12.359-12.359-12.359-32.397,
                          0-44.751 c12.354-12.354,32.388-12.354,44.748,
                          0l171.905,171.915l171.906-171.909c12.359-12.354,
                          32.391-12.354,44.744,0 c12.365,12.354,12.365,32.392,0,
                          44.751L248.292,345.449 C242.115,351.621,234.018,354.706,
                          225.923,354.706z"
                          />
                        </g>
                      </svg>
                    </div>
                  </li>
                </ul>
                <!-- buttons filter mobile -->
              </div>
            </div>
          </div>
        </div>
        <div class="wp_filtersFooterContainer">
          <button
            class="wp_filterApplyButton"
            @click.prevent="closeFilterPopUp"
            data-test="mobileFilterApplyBtn"
            id="mobileFilterApplyBtn"
          >Apply</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { productApi } from '../../../../services/ApiServices/productApi'

export default {
	name: 'mobile-filter',
	data () {
		return {
			filter: {},
			filters: [],
			checkedFilters: [],
			filterCheckbox: false,
			selectedFilters: []
		}
	},
	beforeMount () {
		this.$nextTick(() => {
			this.updateFiltersToLocal()
		})
		if (this.filter && this.filter.filterName) {
			this.selectedFilters = []
			this.filters = this.filter
			this.filters.filName = this.filter.filterName.replace(/\s/g, '')
		}
		this.updatePriceRange([
			parseInt(this.getFilterClassResponse.min_price, 10),
			parseInt(this.getFilterClassResponse.max_price, 10)
		])
	},
	computed: {
		...mapGetters('filters', [
			'getFilters',
			'getFilter',
			'getFilterId',
			'getPriceRange',
			'getKeyWord',
			'emptyFilters',
			'getSelectedFilterValues',
			'isFilterApplied',
			'getFilterClassResponse',
			'getFilterClass',
			'getFilterSelected'
		]),
		...mapGetters('productselected', ['getSelectedProduct'])
	},
	methods: {
		...mapActions('productselected', ['setSelectedProductData']),
		...mapActions('filters', [
			'setFilters',
			'updateFilterId',
			'updatePriceRange',
			'resetFilters',
			'updateFilterApplied',
			'updateFilters',
			'updateKeyWord',
			'setFilterClass',
			'setFilterSelected',
			'setPriceFilterApplied'
		]),
		...mapActions('category', ['setActiveCategories']),
		backButtonAction () {
			if (this.filterCheckbox === true) {
				const contentId = document.getElementById('filterSlidingDivMobile')
				contentId.style.display = 'none'
			} else {
				this.closeFilterPopUp()
			}
			this.filterCheckbox = false
		},
		closeFilterPopUp () {
			this.selectedFilters = []
			const contentId = document.getElementById('filterSlidingDivMobile')
			const filterOverlay = document.getElementById('filterOverlayMobile')
			filterOverlay.style.display = 'none'
			contentId.style.display = 'none'
			document.body.classList.remove('stop-scroll')
		},
		assignFilter (filterData) {
			this.filterCheckbox = true
			this.filter = filterData
			this.selectedFilters = []
			this.filters = this.filter
			this.filters.filName = this.filter.filterName.replace(/\s/g, '')
			if (
				this.checkedFilters.filter(
					fil =>
						fil.filName === filterData.filName && fil.filterValues.length > 0
				).length > 0
			) {
				const previouslyCheckedData = this.checkedFilters.filter(
					fil =>
						fil.filName === filterData.filName && fil.filterValues.length > 0
				)[0]
				this.selectedFilters = previouslyCheckedData.filterValues
			}
		},
		clearAllFilters () {
			this.updateFiltersToLocal()
			this.selectedFilters = []
			this.filters = this.filter
			this.filters.filName = this.filter.filterName.replace(/\s/g, '')
			this.getFilteredProducts(this.checkedFilters)
		},
		filterChanged (filterData) {
			const indexOfChangedFilter = this.checkedFilters
				.map(filter => filter.filterName)
				.indexOf(filterData.filterName)
			this.checkedFilters[indexOfChangedFilter].filterValues =
        filterData.activeFilters
			this.getFilteredProducts(this.checkedFilters)
		},
		getFilteredProducts (filterData, filterType = '') {
			const postDataJson = {}
			postDataJson.filter_class = {}
			let priceFilters = {
				max_price: null,
				min_price: null
			}

			if (this.getPriceRange) {
				priceFilters = {
					max_price: this.getPriceRange[1],
					min_price: this.getPriceRange[0]
				}
			}
			postDataJson.filter_class.filters = []
			postDataJson.filter_class.filters = this.getFilterSelected
			if (this.getFilterClass) {
				Object.assign(postDataJson.filter_class, this.getFilterClass)
			}
			if (filterType === 'priceFilter') {
				// Object.assign(postDataJson.filter_class,filterData)
				postDataJson.filter_class.min_price = filterData.range_min
				postDataJson.filter_class.max_price = filterData.range_max
				this.setPriceFilterApplied(false)
				this.updateFilterApplied(true)
			} else {
				postDataJson.filter_class.filters = filterData.filter(
					value =>
						value.filterValues.length > 0 &&
            value.filterName !== 'ratings' &&
            value.filterName !== 'vendors' &&
            value.filterName !== 'discount above(%)' &&
            value.filterName !== 'discounts above(amount)' &&
            value.filterName !== 'price(upto)'
				)
				const ratingsData = filterData.filter(
					value => value.filterName === 'ratings'
				)
				const vendorsData = filterData.filter(
					value => value.filterName === 'vendors'
				)
				const discountPercentageData = filterData.filter(
					value => value.filterName === 'discount above(%)'
				)
				const discountAmountData = filterData.filter(
					value => value.filterName === 'discount above(amount)'
				)
				const price = filterData.filter(
					value => value.filterName === 'price(upto)'
				)
				let priceFilterValues = []
				priceFilterValues = price[0].filterValues
				let priceFilterLength = 0
				if (priceFilterValues.length > 0) {
					priceFilterValues.sort((a, b) => a - b)
					priceFilterLength = priceFilterValues.length - 1
				}
				postDataJson.filter_class.min_price = priceFilters.min_price
				postDataJson.filter_class.max_price =
          priceFilterValues[priceFilterLength]
				postDataJson.filter_class.ratings = ratingsData[0].filterValues
				postDataJson.filter_class.vendors = vendorsData[0].filterValues
				postDataJson.filter_class.discount_amount =
          discountAmountData[0].filterValues
				postDataJson.filter_class.discount_percentage =
          discountPercentageData[0].filterValues
			}
			this.setFilterClass(postDataJson.filter_class)
			if (postDataJson.filter_class.filters) {
				this.setFilterSelected(postDataJson.filter_class.filters)
			} else if (!this.isFilterApplied) {
				this.setFilterSelected([])
			}
			this.updatePriceRange([
				parseInt(postDataJson.filter_class.min_price, 10),
				parseInt(postDataJson.filter_class.max_price, 10)
			])
			postDataJson.query_parameter = this.getKeyWord
			let urlReference = ''
			if (this.$route.path === '/all-products') {
				urlReference = 'filteredAllProducts'
			} else {
				urlReference = 'filteredSearchProducts'
			}
			productApi
				.getSearchedFilteredProducts(postDataJson, urlReference)
				.then(res => {
					// this.$emit('onLoading', false);
					// this.getPriceFilterProducts();
				})
				.catch(e => {
					// this.$emit('onLoading', false);
				})
		},
		updateFiltersToLocal () {
			this.checkedFilters = JSON.parse(JSON.stringify(this.getFilters))
			if (this.checkedFilters && this.checkedFilters.length > 0) {
				this.checkedFilters.forEach(element => {
					element.filterValues = []
				})
			}
			// this.updateFilters(this.checkedFilters);
		},
		applyFilter () {
			const filterData = {
				activeFilters: this.selectedFilters,
				filterName: this.filter.filterName
			}
			this.filterChanged(filterData)
		}
	},
	watch: {
		getFilter: {
			handler (val) {
				this.$nextTick(() => {
					this.updateFiltersToLocal()
				})
			},
			deep: true
		},
		$route: {
			handler (val) {
				this.filterCheckbox = false
				setTimeout(() => {
					this.updateFiltersToLocal()
				}, 100)
				this.$forceUpdate()
				if (this.filter && this.filter.filterName) {
					this.selectedFilters = []
					this.filters = this.filter
					this.filters.filName = this.filter.filterName.replace(/\s/g, '')
				}
			},
			deep: true
		},
		filter (val) {
			this.filterCheckbox = false
			this.selectedFilters = []
			this.filters = this.filter
			this.filters.filName = this.filter.filterName.replace(/\s/g, '')
		},
		selectedFilters: {
			handler (val) {
				this.updateFilterApplied(false)
				this.checkedFilters.forEach(fil => {
					if (fil.filterValues.length > 0) {
						this.updateFilterApplied(true)
					}
				})
			},
			deep: true
		}
	}
}
</script>
